// React
import React from 'react';
import ReactDOM from 'react-dom/client';

// PrimeReact
import { PrimeReactProvider } from 'primereact/api';
import 'bootstrap/dist/css/bootstrap.css';

// Redux
import { store } from "./app/store";
import { Provider } from "react-redux";

// App
import App from './App';
import { AuthProvider } from './auth/AuthContext';

// Sentry
import { SENTRY_URL } from './config/env';
import * as Sentry from "@sentry/react";

if (SENTRY_URL) {
	Sentry.init({
		dsn: SENTRY_URL,
		sendDefaultPii: true
	});
}

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<PrimeReactProvider>
			<Provider store={store}>
				<AuthProvider>
					<App />
				</AuthProvider>
			</Provider>
		</PrimeReactProvider>
	</React.StrictMode>
);
